/* eslint-disable jsx-a11y/anchor-is-valid */
import './Menu.scss'
import { Link } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import CSKH from '../../Game/CSKH/CSKH'
import { useState } from 'react'

function Menu () {
  const location = useLocation()
  const [showCSKH, setShowCSKH] = useState(false)
  const openCSKHModal = e => {
    e.preventDefault()
    setShowCSKH(true)
  }
  const menuItems = [
    {
      label: 'หน้าหลัก',
      to: '/'
    },
    {
      label: 'หน้าหลัก',
      to: '/casino',
      badge: 'live',
      submenu: [
        {
          img: '/laptop/menu/casino/sa.png',
          name: 'SA GAMING',
          info: 'รับเงินคืนสูงสุด 0.2%'
        },
        {
          img: '/laptop/menu/casino/ae.png',
          name: 'AESEXY GAMING',
          info: 'รับเงินคืนสูงสุด 0.2%'
        },
        {
          img: '/laptop/menu/casino/ag.png',
          name: 'AG GAMING',
          info: 'รับเงินคืนสูงสุด 0%'
        },
        {
          img: '/laptop/menu/casino/dg.png',
          name: 'DG GAMING',
          info: 'รับเงินคืนสูงสุด 0.2%'
        },
        {
          img: '/laptop/menu/casino/evo.png',
          name: 'EVO GAMING',
          info: 'รับเงินคืนสูงสุด 0.2%'
        },
        {
          img: '/laptop/menu/casino/wm.png',
          name: 'WM GAMING',
          info: 'รับเงินคืนสูงสุด 0.2%'
        }
      ]
    },
    {
      label: 'กีฬา',
      to: '/thethao',
      badge: 'hot',
      submenu: [
        {
          img: '/laptop/menu/thethao/bti.png',
          name: 'BTI GAMING',
          info: 'รับเงินคืนสูงสุด 0.2%'
        },
        {
          img: '/laptop/menu/thethao/saba.png',
          name: 'SABA GAMING',
          info: 'รับเงินคืนสูงสุด 0.2%'
        },
        {
          img: '/laptop/menu/thethao/sbo.png',
          name: 'SBO GAMING',
          info: 'รับเงินคืนสูงสุด 0%'
        }
      ]
    },
    {
      label: 'สล็อต',
      to: '/nohu',
      submenu: [
        {
          img: '/laptop/menu/nohu/cq9.png',
          name: 'CQ9 GAMING',
          info: 'รับเงินคืนสูงสุด 0.2%'
        },
        {
          img: '/laptop/menu/nohu/jili.png',
          name: 'JILI GAMING',
          info: 'รับเงินคืนสูงสุด 0.2%'
        },
        {
          img: '/laptop/menu/nohu/MW.png',
          name: 'MW GAMING',
          info: 'รับเงินคืนสูงสุด 0%'
        },
        {
          img: '/laptop/menu/nohu/ns.png',
          name: 'NESTSPIN GAMING',
          info: 'รับเงินคืนสูงสุด 0.2%'
        },
        {
          img: '/laptop/menu/nohu/fc.png',
          name: 'FACHAI GAMING',
          info: 'รับเงินคืนสูงสุด 0.2%'
        },
        {
          img: '/laptop/menu/nohu/pp.png',
          name: 'PP GAMING',
          info: 'รับเงินคืนสูงสุด 0%'
        },
        {
          img: '/laptop/menu/nohu/0.png',
          name: 'JDB GAMING',
          info: 'รับเงินคืนสูงสุด 0.2%'
        },
        {
          img: '/laptop/menu/nohu/smg.png',
          name: 'MG GAMING',
          info: 'รับเงินคืนสูงสุด 0.2%'
        },
        {
          img: '/laptop/menu/nohu/fs.png',
          name: 'FASTSPIN GAMING',
          info: 'รับเงินคืนสูงสุด 0%'
        },
        {
          img: '/laptop/menu/nohu/ps.png',
          name: 'PS GAMING',
          info: 'รับเงินคืนสูงสุด 0.2%'
        },
        {
          img: '/laptop/menu/nohu/yb.png',
          name: 'YB GAMING',
          info: 'รับเงินคืนสูงสุด 0.2%'
        },
        {
          img: '/laptop/menu/nohu/va_s.png',
          name: 'VA GAMING',
          info: 'รับเงินคืนสูงสุด 0%'
        },
        {
          img: '/laptop/menu/nohu/xin.png',
          name: 'PA GAMING',
          info: 'รับเงินคืนสูงสุด 0.2%'
        },
        {
          img: '/laptop/menu/nohu/hb.png',
          name: 'HB GAMING',
          info: 'รับเงินคืนสูงสุด 0.2%'
        },
        {
          img: '/laptop/menu/nohu/ap.png',
          name: 'ADVANTPLAY GAMING',
          info: 'รับเงินคืนสูงสุด 0%'
        }
      ]
    },
    {
      label: 'เกมยิงปลา',
      to: '/banca',
      submenu: [
        {
          img: '/laptop/menu/banca/cewin.png',
          name: 'CEWIN GAMING',
          info: 'รับเงินคืนสูงสุด 0.2%'
        },
        {
          img: '/laptop/menu/banca/fc.png',
          name: 'FC GAMING',
          info: 'รับเงินคืนสูงสุด 0.2%'
        },
        {
          img: '/laptop/menu/banca/jili.png',
          name: 'JILI GAMING',
          info: 'รับเงินคืนสูงสุด 0%'
        }
      ]
    },
    {
      label: 'หวย',
      to: '/xoso'
    },
    {
      label: 'ไก่ชน',
      to: '/daga',
      submenu: [
        {
          img: '/laptop/menu/daga/ws168.png',
          name: 'WS168 GAMING',
          info: 'รับเงินคืนสูงสุด 0%'
        }
      ]
    },
    {
      label: 'โปรโมชั่น',
      to: '/khuyenmai',
      badge: 'hot'
    },
    {
      label: 'บริการลูกค้า',
      to: '#',
      onClick: openCSKHModal
    }
  ]

  return (
    <div className='header_nav'>
      <div className='nav'>
        <div className='wrap'>
          <div className='dynamicNav'>
            {menuItems.map((item, idx) => (
              <div className='nav_item' key={idx}>
                <Link
                  className={`nav_link ${
                    location.pathname === item.to ? 'active' : ''
                  }`}
                  to={item.to}
                  onClick={item.onClick}
                >
                  <span className='nav_icon_text'>{item.label}</span>
                  {item.badge && <span className={item.badge}></span>}
                </Link>

                {item.submenu && (
                  <div className='submenu'>
                    {item.submenu.map((sub, subIdx) => (
                      <div className='submenu_item' key={subIdx}>
                        <a>
                          <img src={sub.img} alt={sub.name} />
                          <span className='game_name'>{sub.name}</span>
                          <span className='game_info'>{sub.info}</span>
                        </a>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
      <CSKH isOpen={showCSKH} onClose={() => setShowCSKH(false)} />
    </div>
  )
}

export default Menu
